import PhotographersDatabaseRow from './PhotographersDatabaseRow'

const PhotographersDatabaseTable = ({ users, searchTerm }) => {
  let result = users

  if (searchTerm) {
    const normalizedSearchTerm = searchTerm.toLowerCase()

    result = users?.filter(
      (user) =>
        user.attributes.guid.toLowerCase().includes(normalizedSearchTerm) ||
        user.attributes.firstName?.toLowerCase().includes(normalizedSearchTerm) ||
        user.attributes.lastName?.toLowerCase().includes(normalizedSearchTerm) ||
        user.attributes.businessName?.toLowerCase().includes(normalizedSearchTerm) ||
        user.attributes.businessUrl?.toLowerCase().includes(normalizedSearchTerm) ||
        user.attributes.email?.toLowerCase().includes(normalizedSearchTerm) ||
        user.attributes.phone?.toLowerCase().includes(normalizedSearchTerm) ||
        user.attributes.referralCode?.toLowerCase().includes(normalizedSearchTerm),
    )
  }

  return (
    <div className="w-layout-grid grid-order-summary-container photographers-database-table">
      {result?.length === 0 && (
        <div className="photographers-empty-state" role="status">
          No photographers found.
        </div>
      )}
      {result?.map((user) => (
        <PhotographersDatabaseRow user={user.attributes} key={user.id} />
      ))}
    </div>
  )
}

export default PhotographersDatabaseTable
